var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReferenceCases(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 112,
    viewBox: "0 0 108 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_611_13513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2037 70.8217L89.9404 50.1878V90.2012C89.9404 90.9751 89.5249 91.7001 88.8488 92.0829L57.7716 110.029L55.2871 111.462C54.611 111.853 53.7801 111.853 53.1121 111.462L50.6275 110.029L19.5504 92.0829C18.8742 91.6919 18.4588 90.9751 18.4588 90.2012V50.1878L54.1955 70.8217H54.2037Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4669 50.1878L54.2037 29.5538L89.9404 50.1878L54.2037 70.8217L18.4669 50.1878Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4669 50.1878L54.2037 70.8217L89.9404 50.1878L54.2037 29.5538L18.4669 50.1878Z",
    fill: "#C1E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0716 103.056L49.0798 96.9461L38.3677 90.6329L38.3596 96.7425L49.0716 103.056Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2036 70.8217L36.877 80.8251C36.543 81.0206 36.1276 81.0206 35.7854 80.8251L1.58018 61.0709C1.14844 60.8184 1.14844 60.1912 1.58018 59.9386L18.4669 50.1878L54.2036 70.8217Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2036 29.5538L71.5303 19.5505C71.8643 19.355 72.2797 19.355 72.6219 19.5505L106.835 39.3047C107.267 39.5572 107.267 40.1844 106.835 40.437L89.9485 50.1878L54.2118 29.5538H54.2036Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2036 70.8217L71.5303 80.8251C71.8643 81.0206 72.2797 81.0206 72.6219 80.8251L106.835 61.0709C107.267 60.8184 107.267 60.1912 106.835 59.9386L89.9485 50.1878L54.2118 70.8217H54.2036Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2036 29.5538L36.877 19.5505C36.543 19.355 36.1276 19.355 35.7854 19.5505L1.58018 39.3047C1.14844 39.5572 1.14844 40.1844 1.58018 40.437L18.4669 50.1878L54.2036 29.5538Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2036 70.8217V111.756",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6936 0.342163L39.8259 2.24834",
    stroke: "#1F2025",
    strokeWidth: 0.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1295 3.60872L39.2394 3.4458",
    stroke: "#1F2025",
    strokeWidth: 0.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0335 3.57612C42.0335 2.74522 44.6809 0.399162 46.7093 0.260679C48.7377 0.122197 50.1958 1.13231 50.2936 2.53343C50.3913 3.93455 49.1042 5.1646 47.0759 5.28679C44.7461 5.42527 42.0335 4.29297 42.0335 3.58427V3.57612Z",
    fill: "#0C57BF",
    stroke: "#0C57BF",
    strokeWidth: 0.59,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6262 4.44773C42.4245 4.21149 44.8764 5.96289 45.5851 7.86907C46.2938 9.77524 45.7318 11.4615 44.4121 11.9502C43.0924 12.439 41.5528 11.5511 40.8686 9.63676C40.0784 7.43733 40.95 4.65138 41.6262 4.45587V4.44773Z",
    fill: "#0C57BF",
    stroke: "#0C57BF",
    strokeWidth: 0.59,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5936 3.97525C42.1312 3.13621 44.7787 3.42132 46.302 4.13003C47.8253 4.83873 48.4688 6.15839 47.9719 7.20923C47.475 8.26007 46.0576 8.62665 44.5425 7.90165C42.8073 7.06261 41.0478 4.82244 41.5854 3.97525H41.5936Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.559 4.93654C41.3733 4.93654 42.0335 4.27641 42.0335 3.46211C42.0335 2.6478 41.3733 1.98767 40.559 1.98767C39.7447 1.98767 39.0846 2.6478 39.0846 3.46211C39.0846 4.27641 39.7447 4.93654 40.559 4.93654Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3607 9.32721C51.3607 9.32721 65.1764 23.2244 60.1747 37.146C57.0792 45.7645 50.1958 48.8926 45.7155 44.2249C43.0436 41.4389 45.5363 34.808 51.9391 37.2274C55.4582 38.5552 65.1601 45.0069 56.2402 60.1748",
    stroke: "#1F2025",
    strokeWidth: 0.47,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_611_13513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106.795,
    height: 112,
    fill: "white",
    transform: "translate(0.602661)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferenceCases);
export default __webpack_public_path__ + "static/media/reference_cases.f04e28c4db29adbdc467927278d8cea4.svg";
export { ForwardRef as ReactComponent };